"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteRecordRelation = exports.postRecordRelation = exports.putRecordOrganization = exports.putRecordAccessibility = exports.deleteRecordPermission = exports.postRecordPermission = exports.delRecord = exports.postRecord = exports.putRecord = exports.getRecord = exports.getRecords = void 0;

var root_1 = require("./root");

var common_1 = require("../common");

var path = root_1.accountingAuthorized + '/records/';

var getRecords = function getRecords(authentication, queryParameters) {
  return common_1.get(authentication, path, queryParameters);
};

exports.getRecords = getRecords;

var getRecord = function getRecord(authentication, id) {
  return common_1.get(authentication, path + id);
};

exports.getRecord = getRecord;

var putRecord = function putRecord(authentication, record) {
  return common_1.put(authentication, path + record.id, record);
};

exports.putRecord = putRecord;

var postRecord = function postRecord(authentication, record) {
  return common_1.post(authentication, path, record);
};

exports.postRecord = postRecord;

var delRecord = function delRecord(authentication, id) {
  return common_1.del(authentication, path + id);
};

exports.delRecord = delRecord;

var postRecordPermission = function postRecordPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, path, id, permission);
};

exports.postRecordPermission = postRecordPermission;

var deleteRecordPermission = function deleteRecordPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, path, id, permissionId);
};

exports.deleteRecordPermission = deleteRecordPermission;

var putRecordAccessibility = function putRecordAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, path, id, accessibility);
};

exports.putRecordAccessibility = putRecordAccessibility;

var putRecordOrganization = function putRecordOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, path, id, organizationId);
};

exports.putRecordOrganization = putRecordOrganization;

var postRecordRelation = function postRecordRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, path, id, relation);
};

exports.postRecordRelation = postRecordRelation;

var deleteRecordRelation = function deleteRecordRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, path, id, relationId);
};

exports.deleteRecordRelation = deleteRecordRelation;